import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { borderRadius, colors } = themeVariables;

/**
 * The circle's diameter, set per card.
 *
 * A custom property rather than an interpolated `css` block, so two sizes do not become
 * two generated classes, the same trade `ReviewPreviewCard` makes for its line counts. The theme
 * has no sizing scale, so the value itself comes from the design via the consumer.
 */
export const LOGO_SIZE_VAR = '--review-card-partner-logo-size';

/* Only ever holds the logo, so the background is what shows through a transparent one and
   while one is still loading. */
export const logo = css`
  display: flex;
  flex-shrink: 0;
  width: var(${LOGO_SIZE_VAR});
  height: var(${LOGO_SIZE_VAR});
  border-radius: var(${borderRadius.full.mobile});
  background-color: var(${colors.surface.disabled});
  overflow: hidden;
`;

export const logoImage = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
